export const PUBLISHED_MESSAGE_QUERY = `
{
  publishedMessage {
    id
    content
    publishedAt
    read
  }
}
`

export const MARK_READ_MUTATION = `
mutation MarkRead($id: Int!) {
  messageMarkRead(id: $id) {
    result {
      id
      readAt
    }
  }
}
`
